import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IExhibitorMeetingCostsPayloadState } from '@app-store/slices/meetingStatistics/exhibitorMeetingCosts'

interface TaskAction extends Action {
    payload: IExhibitorMeetingCostsPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingStatistics.exhibitorMeetingCosts

function* exhibitorMeetingCostsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/stats/exhibitor/costs`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* exhibitorMeetingCostsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, exhibitorMeetingCostsSagaTask)
}

export default exhibitorMeetingCostsSaga
